import {
  createSelector,
} from 'reselect';
import * as R from 'ramda';

import {
  getResourceMappedList,
  getSelectionResourceMappedList,
} from './resources';
import type { Exercise } from '../types';

import {
  sortByOrderName,
  sortByPosition,
} from './utils';

export const getExerciseWithAlternatives = (
  workoutId: number,
  exerciseId: boolean,
) => createSelector(
  getSelectionResourceMappedList('workoutExercises', `workout_${workoutId}`),
  (exercises: any[]) => {
    const exercise = exercises.find((e: any) => e.id === exerciseId);
    exercise.alternatives = exercises.filter((e: any) => e.order_name === exercise.order_name);

    return exercise;
  },
);

const selectedExercises: { [key: string]: any } = {};

export const getSortedListWorkoutExercises = (
  workoutId: number,
  withProperty?: boolean,
) => {
  const key = `${workoutId}_${withProperty ? 1 : 0}`;
  if (selectedExercises[key]) return selectedExercises[key];

  selectedExercises[key] = createSelector(
    [
      getSelectionResourceMappedList('workoutExercises', `workout_${workoutId}`),
      getResourceMappedList('exerciseProperties', `workout_${workoutId}`),
    ],
    (
      exercises,
      properties,
    ): Exercise[] => {
      const list = R.pipe(
        R.groupBy(
          (item: any) => item.order_name,
        ),
        R.values,
        R.reduce((result: any[], items: any[]) => {
          let item = items[0];
          let alternatives: any[] = [];

          if (items.length > 1) {
            item = items.find((i: any) => i.is_selected_alternative) || item;
            alternatives = items.filter((i: any) => i.id !== item.id);
          }

          item.alternatives = alternatives;

          if (withProperty) {
            item.properties = properties
              .filter((p: any) => p.workout_exercise_id === item.id)
              .sort(sortByPosition);

            if (typeof item.hasDieRoll === 'undefined') {
              item.hasDieRoll = item.properties.some((p: any) => p.dieroll_options?.length > 0);
            }
          }

          return [
            ...result,
            item,
          ];
        }, []),
        R.sort(sortByOrderName),
      )(exercises);

      return list;
    },
  );

  return selectedExercises[key];
};
